import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { InctvRbtLineList } from '@/sc/entities/inctvRbtLine/InctvRbtLineList';
import { JobList } from '@/skdr/entities/job/JobList';
import { InctvRbtLedgerPymtList } from '../inctvRbtLedgerPymt/InctvRbtLedgerPymtList';

export const InctvRbtDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'inctvRbtLine', label: 'Lines', content: <InctvRbtLineList inctvRbtId={entityObj.id} /> },
    {
      id: 'inctvRbtLedgerPymt',
      label: 'Ledgers & Payments',
      content: <InctvRbtLedgerPymtList inctvRbtId={entityObj.id} />,
    },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="INCTV_RBT" parentEntityId={entityObj.id} /> },
    {
      id: 'approvals',
      label: 'Approvals',
      disabled: !entityObj.apprJobId,
      content: <JobList chain jobId={entityObj.apprJobId} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
